import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const SavingsCard = ({ icon, title, description, dir = 'ltr' }) => {
  const maxWidth = 275;
  const [cardWidth, setCardWidth] = useState(maxWidth);
  const [padding, setPadding] = useState(28);
  const [iconSize, setIconSize] = useState(50);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    function updateStyles() {
      if (typeof window === 'undefined') return;
      const w = window.innerWidth;
      if (w <= 420) {
        setCardWidth('calc(100% - 32px)');
        setPadding(20);
        setIconSize(56);
      }
      // else if (w <= 768) setCardWidth('calc(50% - 24px)');
      else {
        setCardWidth(maxWidth);
        setPadding(28);
        setIconSize(50);
      }
    }
    updateStyles();
    window.addEventListener('resize', updateStyles);
    return () => window.removeEventListener('resize', updateStyles);
  }, []);

  const textAlign = dir === 'rtl' ? 'right' : 'left';
  const alignItems = 'stretch';
  const iconJustify = dir === 'rtl' ? 'flex-end' : 'flex-start';

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: cardWidth,
        height: 150,
        background: '#fff',
        borderRadius: 12,
        padding: padding,
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.13)' : '0 4px 12px rgba(0,0,0,0.06)',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        alignItems: alignItems,
        textAlign: textAlign
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', justifyContent: 'flex-start', marginBottom: 20 }}>
        <img src={icon} alt="icon" style={{ width: iconSize, height: iconSize, objectFit: 'contain', marginLeft: dir === 'rtl' ? 'auto' : 0 }} />
      </div>

      <div style={{ width: '100%', fontSize: 20, fontWeight: 500, color: '#111', textAlign: textAlign, marginBottom: 6 }}>{title}</div>
      <div style={{ width: '100%', fontSize: 15, fontWeight: 400, color: '#79818f', textAlign: textAlign }}>{description}</div>
    </div>
  );
};

SavingsCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  dir: PropTypes.string
};

export default SavingsCard;
